import { render, staticRenderFns } from "./pautageral.vue?vue&type=template&id=4a8c28d4&"
import script from "./pautageral.vue?vue&type=script&lang=js&"
export * from "./pautageral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports